















































































































































import debounce from 'lodash/debounce';

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';
import { validationMixin } from 'vuelidate'
import { required, requiredIf, minLength, sameAs } from 'vuelidate/lib/validators'

import { getFieldError } from '@/core/tools/forms/get_field_error';

import ProductCombobox from '@/components/Controls/ProductCombobox.vue';
import ProductContainerCombobox from '@/components/Controls/ProductContainerCombobox.vue';

import { STORE_KEY, store } from './_store';

@Component({
  mixins: [ validationMixin ],
  computed: {
    ...mapState(STORE_KEY, [
      'loaded', 'loading', 'fatalError',
      'form', 'meta', 'product_rels',
    ]),
    ...mapGetters(STORE_KEY, [
      'fields'
    ])
  },
  methods: {
    getFieldError
  },
  validations() {
    const rules: any = {
      client_id: { required },
      product_container_id: { required },
      container_price: { required },
      input_quantity: {},
      hidden: {},
      hidden_date: {},
      is_recomended: {},
    }

    return {
      form: rules
    }
  },
  components: {
    ProductCombobox,
    ProductContainerCombobox
  }
})
export default class ClientPriceElementForm extends Vue {
  @Prop({ type: Boolean }) isNew!: boolean;
  @Prop({ type: Object }) documentPreview!: any;
  @Prop({ type: Object }) initParams!: any;

  document!: any
  form!: any
  product_rels!: any

  public isSuggestionsFetching = false;
  public suggestions: any[] = [];
  public filters: any = {
    product_id: null,
    product: {}
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    if (this.isNew) {
      this.$store.dispatch(`${STORE_KEY}/prepareNew`, this.initParams);
    } else {
      this.$store.dispatch(`${STORE_KEY}/init`, {
        id: this.documentPreview.id
      });
    }
  }

  setProduct(product: any) {
    this.filters.product_id = product.id
    this.filters.product = product
  }

  addProduct(product: any) {
    console.log(product)
    const product_ids: any[] = this.product_rels.map((manager: any) => manager.client_product_container_rel_id);
    if (product && !product_ids.includes(product.id)) {
      this.$store.dispatch(`${STORE_KEY}/addProduct`, {
        id: product.client_product_container_id, 
        label: this.filters.product.label + ' ' + product.label
      });
      this.filters.product_id = null
      this.filters.product = {}

    }
  }
  removeProduct(index: any) {
    if (index > -1) {
      this.$store.dispatch(`${STORE_KEY}/removeProduct`, index);
    }
  }

  changeValue(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      field, newValue: value
    });

    // @ts-ignore
    this.$v.form[field].$touch();
    // this.$v.form.$touch();
  }

  getAsyncData(name: any){
    if (!name.length) {
        this.suggestions = [];
        return;
    }
    this.isSuggestionsFetching = true;

    (this as any).$http
      .post(`/api/v1/dadata/suggestions/api/4_1/rs/suggest/party`, JSON.stringify({ "query": name }))
        .then(({ data }: any) => {
          this.$set(this, 'suggestions', data.suggestions);
        })
        .catch((error: any) => {
            this.suggestions = [];
            throw error
        })
        .finally(() => {
            this.isSuggestionsFetching = false
        })
  }

  getAsyncDataDebounce = debounce(this.getAsyncData, 500)

  initFromSuggestion({ value, data, unrestricted_value }: any) {
    this.changeValue('name', value);
    this.changeValue('inn', data.inn);
    this.changeValue('kpp', data.kpp);
  }

  saveFormData() {
    this.$v.form.$touch()

    if(!this.$v.form.$error) {
      this.$store.dispatch(`${STORE_KEY}/saveForm`, this.documentPreview ? this.documentPreview.id : null)
      .then((result) => {
        this.$buefy.snackbar.open(`Данные успешно сохранены`);
        this.$v.form.$reset();

        this.$emit('form-close');
        (this.$parent as any).close();
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })
    }

  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    // this.$store.unregisterModule(STORE_KEY);
  }
}

